import React, { FC } from 'react';

type PropsType = {
  avatarImg: string;
};

export const SelectedAvatarIcon: FC<PropsType> = ({ avatarImg }: PropsType) => {
  return (
    <div className="avatar-overlay">
      <img className="avatar-img avatar" src={avatarImg} alt="avatar" />
    </div>
  )
};
